import React from 'react'
import "./mainTitle.scss"

interface MainTitleProps {
  className?: string;
  mainText?: string;
}

const MainTitle: React.FC<MainTitleProps> = ({ className = "", mainText }) => {
  return (
    <div className={`main-title ${className}`}>
      <h2 className='title-text'>{mainText}</h2>
    </div>
  )
}

export default MainTitle